<script lang="ts">
  import Modal from './ui/Modal.svelte';
  import { actionDialog } from '$lib/state/actionDialog.svelte';
</script>

{#if actionDialog.current}
  <div class="relative z-[80]">
    <Modal title="Please confirm" onClose={() => actionDialog.decide(false)}>
      <p class="mb-5 text-sm text-navy">{actionDialog.current.message}</p>
      <div class="flex justify-end gap-3">
        <button type="button" class="btn-secondary" onclick={() => actionDialog.decide(false)}>Cancel</button>
        <button type="button" class="btn-danger" onclick={() => actionDialog.decide(true)}>Confirm</button>
      </div>
    </Modal>
  </div>
{/if}
{#if actionDialog.pending.length}
  <section aria-label="Pending actions" aria-live="polite" class="fixed bottom-5 left-1/2 z-[90] w-[min(92vw,460px)] -translate-x-1/2 space-y-2">
    {#each actionDialog.pending as item (item.id)}
      <div class="flex items-center justify-between gap-4 rounded-xl bg-navy px-4 py-3 text-sm text-white shadow-lg">
        <span>{item.label} in 5 seconds</span>
        <button type="button" class="min-h-11 px-3 font-semibold underline" onclick={() => actionDialog.undo(item.id)}>Undo</button>
      </div>
    {/each}
  </section>
{/if}
